<template>
  <div class="mb-5">
    <section><!--news feed-->
      <v-parallax src="/static/img/background-video.png" height="550">
        <v-layout column align-center justify-start class="white--text mr-5 mb-3 pt-3">
          <div class="white--text mt-5 text-md-center text-shadow" v-if="currentRegion">
            <h1 class="text-executive-lg uppercase">Visit our outlets</h1>
            <h2 class="text-executive-md mb-3">in</h2>
            <h1 class="text-executive-lg uppercase">{{currentRegion.name }}</h1>
          </div>
        </v-layout>
      </v-parallax>
    </section><!--/news feed-->

    <section><!--feed-->
      <v-layout row wrap px-5>
        <v-flex xs12>
          <v-container grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-card color="transparent"
                        class="white--text mb-3 pointer outlet-card"
                        :key="outlet.id"
                        @click.native="viewDetail(outlet)"
                        v-for="outlet in outlets">
                  <v-container fluid grid-list-lg class="gd-border-solid">
                    <v-layout row wrap>
                      <v-flex xs12 md9>
                        <div>
                          <div class="headline mb-2 text-executive-lg-black bold text-xxl">{{ outlet.name }}</div>
                          <div class="mb-2 text-courier-new-xs-black wordwrap">
                            <OutletAddressCard :current-outlet="outlet" color="black" class="text-black" />
                          </div>
                          <span class="bold">
                            <a>CLICK FOR MORE INFO</a>
                          </span>
                        </div>
                      </v-flex>
                      <v-flex xs12 md3 align-end justify-end row wrap>
                        <v-card-media
                          :src="getPath(getFirstImage(outlet))"
                          height="125px"
                          width="210px"
                          contain
                        ></v-card-media>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section><!--/feed-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OutletAddressCard from './OutletAddressCard.vue'

export default {
  name: 'outlet-list',
  components: { OutletAddressCard },
  data () {
    return {
      param: {}
    }
  },
  created () {
    this.getOutlets()
  },
  computed: {
    ...mapGetters(['outlets', 'regions']),
    paramsRegionId () {
      return this.$route.params.regionId
    },
    currentRegion () {
      return this.regions.find(region => region.id.toString() === this.paramsRegionId.toString())
    }
  },
  methods: {
    getOutlets () {
      this.$store.dispatch('getOutlets', {
        data: {
          region_id: this.paramsRegionId
        },
        success: () => {},
        fail: () => {}
      })
    },
    viewDetail (outlet) {
      this.$router.push(`/outlets/list/${this.paramsRegionId}/${outlet.id}`)
    },
    getFirstImage (outlet) {
      const obj = outlet.photos[0]
      return obj && obj.image_url
    },
    getPath (fileName) {
      if (fileName === undefined) {
        return '/static/img/news/default-210.png'
      }
      if (fileName.startsWith('http')) {
        return fileName;
      }
      return 'https://api.kopiketjil.com' + fileName
    }
  },
  watch: {
    '$route.params' () {
      this.getOutlets()
    }
  }
}
</script>

<style lang="scss" scoped>
.outlet-card {
  background-color: white;
  background-size: cover;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/OutletList.vue